import React, { Component } from "react";
import WithRoutify from "../../../../../hoc/WithRoutify";
import Buttons from "../../../../../components/UI/Buttons";
import AddActivities from "../../../EmployeeVisitDetailView/RightContent/PhysicalTab/AddActivities";
import {capitalizeName, isSet,getLocation,formatPhoneNumberUS } from "../../../../../utils/commonUtils";
import TableGrid from "../../../../../components/UI/TableGrid";
import VisitsService from "../../../../../services/VisitsService";
import ActivitiesService from "../../../../../services/ActivitiesService";
import Icons from "../../../../../components/UI/Icons";
import ActivityChartsContent from "../ActivityConsent";
import FileManagerService from "../../../../../services/FileManagerService";
import PatientChartsService from "../../../../../services/PatientChartsService";
import WithRouter from "../../../../../hoc/WithRouter";
import AddLab from "../../../AddLab";
import AddVaccine from "../../../AddVaccine";
import DropDownService from "../../../../../services/DropDownService";
import AssignCompany from "../../../EmployeeVisitDetailView/RightContent/PhysicalTab/AssignCompany";
import { PDFDocument, PDFName, PDFNumber } from 'pdf-lib';
import StatusBar from "./StatusBar";
import PERMISSIONS from "../../../../../utils/AclPermissions";
import SearchOverAllStatus from "../SearchOverAllStatus";
import ActivityChart from "../../../EmployeeVisitDetailView/RightContent/ActivityChart";
import PatientFormService from "../../../../../services/PatientFormService";
import { connect } from "react-redux";
import { activeProfileDetails } from "../../../../../store/SessionSlice";

class PhysicalTab extends Component {
  
  constructor(props) {
    super(props);
    const tableHeaders =  [
      // { label: '',key:'statusicon'},
      { label: 'Activity Name',key:'activity_name',noTruncate: true },
      { label: 'Activity Type',key:'activity_type'},
      { label: 'Status',key:'status'},    
      { label: 'Consent Status',key:'consent'},
      // { label: 'Signatory', key: 'signatory' },
      { label: 'Action',key:'action',type:'Actions'},
      // Add more columns as needed
    ];
    this.state = {
      overAllStatus:'Pending',
      // Add any default state properties here if needed
      isModelOpen:false,
      // isVaccineModelOpen is kept for reference; vaccine orders now use ActivityChart
      // isVaccineModelOpen:false,
      isLabModelOpen:false,
      isActivityChartOpen:false,
      isActivityConsentOpen:false,
      isAssignCompany: !isSet(this.props.visitDetails.company),
      assignCompanyOptions:[],
      activityChartDetails:{},
      tableRecords:{
        tableHeaders:tableHeaders,
        tableRows:{
            data:[]
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          search_query:'',
        },
    },
    };
  }
  
  componentDidMount =() =>{
    // Add any logic you want to execute after the component is mounted
    this.fetchPhysicalList();
    requestAnimationFrame(() => this.tryOpenActivityChartFromRoute());
    // this.fetchOptions();
  }

  /** Open chart from deep link — does not toggle (avoids double-invoke closing the modal). */
  openActivityChartFromDeepLink = (chartDetails) => {
    this.setState({
      isActivityChartOpen: true,
      activityChartDetails: chartDetails,
    });
  };

  tryOpenActivityChartFromRoute = () => {
    const searchParams = new URLSearchParams(this.props.location?.search || "");
    const fromQuery =
      searchParams.get("activityMappingId") || searchParams.get("activity_mapping_id");
    const fromState = this.props.location?.state?.openChartMappingId;
    const openChartMappingIdRaw = fromState || fromQuery;
    const openChartMappingId = openChartMappingIdRaw != null ? String(openChartMappingIdRaw).trim() : "";
    const visitId =
      this.props.visitDetails?.visit_id ||
      this.props.visitDetails?.["0"]?.visit_id ||
      null;
    const rows = this.props.visitDetails?.mapping_activity?.data?.data;
    if (!openChartMappingId || !Array.isArray(rows)) {
      return;
    }
    const targetId = openChartMappingId;
    const activity = rows.find(
      (item) => item?.activity && String(item.mapping_id) === targetId
    );
    const pagination = this.props.visitDetails?.mapping_activity?.pagination;
    const totalCount = pagination?.totalCount != null ? Number(pagination.totalCount) : rows.length;
    if (!activity?.activity && visitId && totalCount > rows.length && !this._activityDeepLinkPageFetch) {
      this._activityDeepLinkPageFetch = true;
      const perPage = Math.min(500, Math.max(totalCount, rows.length || 25));
      this.props.fetchVisitDetails(visitId, { page: 1, perPage, search_query: "" });
      return;
    }
    if (!activity?.activity) {
      this._activityDeepLinkPageFetch = false;
      return;
    }
    this._activityDeepLinkPageFetch = false;
    this.openActivityChartFromDeepLink({
      ...activity.activity,
      mapping_id: activity.mapping_id,
      questionnaires_status: activity.questionnaires_status,
    });
    const navigate = this.props.navigate;
    if (!navigate) return;
    if (fromState) {
      navigate(this.props.location.pathname, { replace: true, state: {} });
    }
    if (fromQuery) {
      searchParams.delete("activityMappingId");
      searchParams.delete("activity_mapping_id");
      const nextSearch = searchParams.toString();
      const nextPath = this.props.location.pathname + (nextSearch ? `?${nextSearch}` : "");
      setTimeout(() => {
        navigate(nextPath, { replace: true, state: this.props.location.state || {} });
      }, 0);
    }
  };

  componentDidUpdate = (prevProps) =>{
    const visitChanged = prevProps.visitDetails !== this.props.visitDetails;
    const searchChanged = prevProps.location?.search !== this.props.location?.search;
    if (visitChanged) {
      this.fetchPhysicalList();
    }
    if (visitChanged || searchChanged) {
      this.tryOpenActivityChartFromRoute();
    }
    // if (prevProps.tabId!=this.props.tabId) { //re-render when tab id changs 
    //   this.fetchPhysicalList();
    // }
    // Add any logic you want to execute when props are updated
    // You can compare this.props and prevProps to determine changes
  }

  componentWillUnmount() {
    // Add any cleanup logic when the component is about to unmount
  }
  addToogleHandler = ()=>{
    this.setState({isModelOpen:!this.state.isModelOpen})
  }
  assignTabToggleHandler = ()=>{ 
    this.setState({isAssignCompany:!this.state.isAssignCompany})
  }
  
  activityConsentToogleHandler = (chartDetails={})=>{
    this.setState({isActivityConsentOpen:!this.state.isActivityConsentOpen,activityChartDetails:chartDetails});
  }
  activityChartToogleHandler = (chartDetails={})=>{
    this.setState({isActivityChartOpen:!this.state.isActivityChartOpen,activityChartDetails:chartDetails});
  }
  sendQuestionnaireHandler = async (mapping_id) => {
        const {params,Loader,Toast,visitDetails} = this.props;
        console.log('visitDetails',this.state.activityChartDetails);
          // console.log(visitDetails);
          try {
              Loader(true);
              const payload = {
                  "employee_id": visitDetails.employee.employee_id,
                  "visit_id": visitDetails[0].visit_id,
                  // "mapping_id": this.state.activityChartDetails.mapping_id, 
                  "mapping_id": mapping_id,
                  "baseUrl": process.env.REACT_APP_BASEURL,
              };
                let data = await PatientFormService.sentPatientQuestionnaire(payload);
              // console.log('data', data);
  
  
              if (data.status && data.status === "ERROR") {
                  Loader(false);
                  Toast.error(data.data);
                  this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});
              } else {
                  Loader(false);
                  this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});
                  Toast.success('Questionnaire Send Successfully');
  
              }
          } catch (err){
                  Loader(false);
                  Toast.error('something went wromg!');
                  this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});
          }
      }
  SearchHandler = (search_query)=>{
    let {pagination} = this.state.tableRecords;
    const filterdata={
      perPage: pagination.perPage,
      page: 1,
      search_query: search_query
    }
    pagination.search_query = search_query
    pagination.page = 1;
    this.setState({tableRecords:{...this.state.tableRecords,pagination:pagination}},()=>{
      this.props.fetchVisitDetails(this.props.visitDetails.visit_id,filterdata);
    });
  }
  ClearSearch=()=>{
    this.setState({tableRecords:{...this.state.tableRecords,pagination:{...this.state.tableRecords.pagination,search_query:''}}})
  }
  fetchdetails=(filter)=>{
    const pagination = {  
      perPage: filter.perPage,
      page: filter.page,
      search_query: isSet(filter.search_query,'')
    }
    this.props.fetchVisitDetails(this.props.visitDetails.visit_id,pagination);
  }
  
  render() {
    const { assignCompanyOptions,isAssignCompany,isModelOpen,isActivityChartOpen,activityChartDetails,overAllStatus,isActivityConsentOpen } = this.state;
    const {visitDetails} = this.props;
    const {company_physical} = visitDetails;
    let statusClr = 'blue';
     if(overAllStatus.toLowerCase()==='passed'){
      statusClr = 'green';
    } else  if(overAllStatus.toLowerCase()==='failed'){
      statusClr = 'red';
    } 
    // console.log('company_physical',visitDetails);
    console.log("EMployeeId",this.props.employeeId)
    return (
      <>
        {
          this.state.isLabModelOpen ?
          
            <AddLab
              modelTitle={"Add Lab"}
              isOpen={true}
              visitId={visitDetails.visit_id}
              mapping_id={activityChartDetails.mapping_id}
              modalToogleHandler={this.addLabToogleHandler}
              fetchRecords={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
              fromChart={true}
            />
            :
            ''
        }
        {/* Vaccine modal is deprecated in favor of ActivityChart, but kept for reference
        {
          this.state.isVaccineModelOpen ?
            <AddVaccine
              modelTitle={"Add Vaccine"}
              isOpen={true}
              visitId={visitDetails.visit_id}
              mapping_id={activityChartDetails.mapping_id}
              modalToogleHandler={this.addVaccineToogleHandler}
              fetchRecords={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
              fromChart={true}
            />
            : ''

        } */}
      {
        isModelOpen?
        ( isAssignCompany ? <AssignCompany
              modelTitle={"Assign Company"}
              isOpen={this.state.isAssignCompany}
              addToogleHandler={this.addToogleHandler}
              assignToggleHandler={this.assignTabToggleHandler}
              fetchVisitDetails={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
              options={assignCompanyOptions}
              employee_id={this.props.visitDetails.employee.employee_id}
        /> :<AddActivities
              modelTitle={"Add Activities"}
              isOpen={this.state.isModelOpen}
              fetchVisitDetails={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
              addToogleHandler={this.addToogleHandler}
              options={this.props.physicalOption}
              visitDetails={visitDetails}
            />)
        :(isActivityChartOpen)?
          <ActivityChart 
            chartDetails={activityChartDetails}
            isOpen={isActivityChartOpen}
            visitDetails={this.props.visitDetails}
            fetchVisitDetails={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
            stateList={this.props.stateList}
            employeeDetails={this.props.employeeDetails}
            lookupsOptions={this.props.lookupsOptions}
            companyDetails={this.props.companyDetails}
            toogleHanlder={this.activityChartToogleHandler} 
            employeeId={this.props.employeeId}
            fetchEmployeeDetails={this.props.fetchEmployeeDetails}
            />
        :(isActivityConsentOpen)?
          <ActivityChartsContent 
            chartDetails={activityChartDetails}
            isOpen={isActivityConsentOpen}
            visitDetails={this.props.visitDetails}
            fetchVisitDetails={()=>{this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});this.ClearSearch()}}
            stateList={this.props.stateList}
            employeeDetails={this.props.employeeDetails}
            lookupsOptions={this.props.lookupsOptions}
            companyDetails={this.props.companyDetails}
            toogleHanlder={this.activityConsentToogleHandler} />
        :''
      }
         
          <div className="sh_cardBox sh_visitcardht">
                <div class="sh_cardHeader">
                  <SearchOverAllStatus ishow={true} addToogleHandler={this.addToogleHandler} searchTerm={this.state.tableRecords.pagination.search_query} SearchHandler={this.SearchHandler} data={this.state.tableRecords.tableRows.data} visitDetails={visitDetails} overAllStatus={overAllStatus} printClearanceReport={this.printClearanceReport}
                  printConsentHandler={this.printConsentHandler}
                  />
           
                </div>
                <div className="sh_cardHeader rounded-2" style={{background: 'linear-gradient(90deg, #FFF7DC 0%, #F7E9E5 100%)'}}>
                  <div className="d-flex justify-content-center">
                    <div className="form-group d-flex mb-0 justify-content-between align-items-center">
                      <StatusBar
                        visitDetails={visitDetails}
                      />
                      {/* <div className="addAction d-flex justify-content-between align-items-center printbtn-status">
                        <Buttons
                          title={"Add Physical / Drug Screen"}
                          disableButtonTitle={"This Visit is Already Billed / No Permission"}
                          className="btn btn-icon btn-transparent-dark mr-2"
                          acl={visitDetails.billing_status == 'Billed' ? PERMISSIONS.NO_PERMISSION : PERMISSIONS.VISITS.EDIT}
                          iconType={"AddIconDetailView"}
                          clickHandler={this.addToogleHandler}
                        /> */}
                        {/* <a className=" btn  btn-outline-primary dropdown dropdown-toggle position-static noArrow" data-bs-toggle="dropdown" title="Print">
                          <span >
                            <i className="fas fa-print text-md " /> Print Report
                          </span>

                          <div className="dropdown-menu dropdown-menu-left shadow" aria-labelledby="userDropdown">
                            <div className="dropdown-item" href="#" onClick={() => this.printClearanceReport()}>
                              Clearance Report
                            </div>
                            <div className="dropdown-item" href="#" onClick={() => this.printConsentHandler('consent form')}>
                              Print Consents
                            </div>

                          </div>
                        </a> */}
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="sh_cardBody pt-0 mt-3"
                  // style={{ height: "calc(100% - 120px)" }}
                  >
                  <TableGrid {...this.state.tableRecords}  fetchTableRecords={(filters) =>this.fetchdetails(filters)} hasPagination ={true}/>
                   
                </div>
               
              </div>
               
                      
      </>
    );
  }
  printClearanceReport = async ()=>{
    const {params,Loader,Toast} = this.props;
    const visitId = params.visitId;
    Loader(true);
    try{
        const data = await PatientChartsService.getClearanceReportPDF(null,visitId);
        if (!data) {
          Toast.error("Clearance Report Not Found");
          Loader(false);
          return;
        }
        const pdfData = {
            file_content:data,
            original_name:`clearance-report`,
            mime_type:'application/pdf'
            
        }
        FileManagerService.printPdf(pdfData);
    }catch(e){
      console.log('e',e);
      Toast.error("Error while fetching Clearance Report" );

    }
    Loader(false);
}

  printMedicalExaminationPdfs = async (mappingId,type,pdfName)=>{
    const {params,Loader} = this.props;
    // const visitId = params.visitId;
    Loader(true);
    try{
      let data, existingPdfBytes;
      if(type== 'CERT'){
        data = await PatientChartsService.getMedicalExaminerCertificatePDFData(null,mappingId);
      }else if (type== 'DOT'){
        data = await PatientChartsService.getMedicalExaminationReportPDFData(null,mappingId);
      }
      existingPdfBytes = await fetch(`/assets/pdfs/${pdfName}.pdf`).then(res => res.arrayBuffer());
        console.log('Fetching PDF...');
        console.log(data);
        console.log('Fetched PDF file successfully:', existingPdfBytes);
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const form = pdfDoc.getForm();
        const fields = form.getFields();

    //   fields.forEach(field => {
    //   const name = field.getName();
    //   console.log('Field name:', name);
    //   console.log(field.constructor.name );
    // });

 Object.keys(data).forEach((key) => {
  try{ 
    const field = form.getField(key); // Get the field using the key
  
  if (field) {
    let value =  data[key].toString() ; // Ensure the value is a string or fallback
   
    const name = field.getName();
    //   console.log('Field name:', name);
    //   console.log(field.constructor.name );
    // console.log(value);

    if(name === 'examPhone' || name === 'driverPhone' || name === 'medicalPhone' || name === 'medicalPhoneState'){
     console.log('name' , name , value);
     value = formatPhoneNumberUS(value);
      console.log('name' , name , value);
    }
    
    if (value !== '--') {
    // Check if this is the expiration date field
    // Check both PDF field name and backend data key
    const expirationDateFieldNames = [
      'medical_examiners_certificate_expiration_date',
      'Text1', 'Text2', 'Text3', 'Text4', 'Text6',
      'expireDate', 'expireDateState'
    ];
    const isExpirationDate = expirationDateFieldNames.includes(name) || expirationDateFieldNames.includes(key);
    
    // Check field type using field.constructor.name
    switch (field.constructor.name) {
      case 'PDFTextField':  
      try{ 
          field.setText(value);
          if (isExpirationDate) {
            field.enableReadOnly();
          }
        }catch(e){
          console.log('e',field.getName(),field.constructor.name,e);
        }
        break;
      case 'PDFDropdown':
        try{ 
// Function to select the dropdown value
const selectDropdownValue = (field, value) => {
  const dropdownOptions = field.getOptions(); // Get all dropdown options
  
  // Get the full name from the abbreviation if it's a state; otherwise, use the value directly
  const stateKeyValue = getLocation(value); // e.g., { AK: 'Alaska' } or null
  const fullName = stateKeyValue ? Object.values(stateKeyValue)[0] : value;

  // console.log(`The key is: ${key}`);

if(stateKeyValue){
  const key = Object.keys(stateKeyValue)[0]; // Extracts 'AK'
 if (dropdownOptions.includes(key)) {
  field.select(key);
} else {
  console.warn(`The key '${key}' is not available in the dropdown.. Field Name - '${field.getName()}'`);
  console.warn(`Dropdown options - '${dropdownOptions}'`);
}
}
  // Check if the dropdown contains the passed value (e.g., 'AK' or 'fight')
  if (dropdownOptions.includes(value)) {
    field.select(value);
  }
  // Check if the dropdown contains the full name (e.g., 'Alaska')
  else if (dropdownOptions.includes(fullName)) {
    field.select(fullName);
  }
  // Log a warning if neither is found
  else {
    console.warn(`Value '${value}' or its full name '${fullName}' is not available in the dropdown.`);
  }
};

// Example Usage for States
selectDropdownValue(field, value);
if (isExpirationDate) {
  field.enableReadOnly();
}    
}catch(e){
  console.log('e',field.getName(),field.constructor.name,e);
}
        break;
      case 'PDFCheckBox':
        // Check/uncheck a checkbox based on the value
        try{
        if (value === 'Yes' || value === 1 || value=== '1') {
          // console.log('check');
          field.check();
        } else {
          field.uncheck();
        }
        if (isExpirationDate) {
          field.enableReadOnly();
        }
      }catch(e){
        console.log('e',field.getName(),field.constructor.name,e);
      }
        break;
      case 'PDFRadioGroup':

        try{
            const options = field.getOptions(); 
            console.log(options);     
            field.select(value);
            if (isExpirationDate) {
              field.enableReadOnly();
            }
                  
      }catch(e){
        console.log('e',field.getName(),field.constructor.name,e);
      }
         
        break;
      default:
        console.warn(`Field '${key}' is of unsupported type: ${field.constructor.name}`);
        break;
      }
   }
  } else {
    console.warn(`Field '${key}' not found in the form.`);
  }
}catch(e){
  console.log('e',e);
}
});

      if (type == 'CERT') {
        try{
        if(data.examinerSignature && data.examinerSignature !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.examinerSignature).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(0); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 160,  // X coordinate where the signature will appear
            y: 274,  // Y coordinate for the signature
            width: 100,  // Signature image width
            height: 30,  // Signature image height
          });
        }
        if(data.driverSignature && data.driverSignature !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.driverSignature).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(0); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 130,  // X coordinate where the signature will appear
            y: 130,  // Y coordinate for the signature
            width: 100,  // Signature image width
            height: 30,  // Signature image height
          });
        }
      }catch(e){
        console.log('e',e);
      }
      } else if (type == 'DOT') {
         try{
        if(data.driverSignature && data.driverSignature !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.driverSignature).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(1); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 130,  // X coordinate where the signature will appear
            y: 183,  // Y coordinate for the signature
            width: 60,  // Signature image width
            height: 18,  // Signature image height
          });
        }
        if(data.amendedExaminerSignature && data.amendedExaminerSignature !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.amendedExaminerSignature).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(3); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 250,  // X coordinate where the signature will appear
            y: 510,  // Y coordinate for the signature
            width: 60,  // Signature image width
            height: 20,  // Signature image height
          });
        }
        if(data.examinerSignatureFederal && data.examinerSignatureFederal !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.examinerSignatureFederal).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(3); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 180,  // X coordinate where the signature will appear
            y: 425,  // Y coordinate for the signature
            width: 70,  // Signature image width
            height: 20,  // Signature image height
          });
        }
        if(data.examinerSignatureState && data.examinerSignatureState !== '--'){
          //  Embed the signature image (PNG or Base64)
          const signatureBytes = await fetch(data.examinerSignatureState).then(res => res.arrayBuffer());
          const signatureImageEmbed = await pdfDoc.embedPng(signatureBytes);

          const page = pdfDoc.getPage(4); // Specify the page number where you want to insert the signature
          page.drawImage(signatureImageEmbed, {
            x: 160,  // X coordinate where the signature will appear
            y: 524,  // Y coordinate for the signature
            width: 70,  // Signature image width
            height: 20,  // Signature image height
          });
        }
      }catch(e){
        console.log('e',e);
      }
      
      }

        const pdfBytes = await pdfDoc.save();
    
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);
        
        // Open PDF in new tab instead of downloading
        const newWindow = window.open(blobUrl, '_blank');
        
        // Clean up the blob URL after a longer delay to ensure Chrome has loaded the PDF
        // Only revoke if the window was successfully opened
        if (newWindow) {
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
          }, 5000); // Increased to 5 seconds to give Chrome time to load the PDF
        }

    }catch (e) {
      console.error('Error occurred while processing the PDF:', e);
    } finally {
      Loader(false); // Ensure the loader is hidden even if an error occurs
    }
  }
  
  printConsentHandler = async (labelName)=>{
    const {params,Loader,Toast} = this.props;
    const {activityChartDetails} = this.state;
    const activity_name = activityChartDetails.activity_name;
    const visitId = params.visitId;
    const queryfilters = {
        activity_name:(activity_name),
    }
    Loader(true);
    try{
        const data = await PatientChartsService.getPrintConsent(null,queryfilters,visitId);
        if (!data) {
          Toast.error("Consents Form Not Found");
          Loader(false);
          return;
        }
        const pdfData = {
            file_content:data,
            original_name:`${labelName}`,
            mime_type:'application/pdf'
            
        }
        FileManagerService.printPdf(pdfData);
    }catch(e){
      console.log('e',e);
      Toast.error("Something went wrong " );

    }
    Loader(false);
}

  statusDetector = (status) => {
  return <div class={`badge ${status.toLowerCase() == 'passed' || status.toLowerCase() == 'normal' || status.toLowerCase() == 'negative' || status.toLowerCase() == 'confirmed negative' || status.toLowerCase() == 'administrated' || status.toLowerCase() == 'dispensed' || status.toLowerCase() == 'administered' ? 'sh_badgeSuccess' : status.toLowerCase() == 'not started' || status.toLowerCase() == 'not administered'  ? 'sh_badgePending' : status.toLowerCase() == 'failed' || status.toLowerCase() == 'cancelled' || status.toLowerCase() == 'abnormal' || status.toLowerCase() == 'positive' || status.toLowerCase() == 'confirmed positive' || status.toLowerCase() == 'fail' || status.toLowerCase() == 'abnormal' ? "sh_badgeDanger" : 'sh_badgeWarning'} `}>
      <span class="pr-1">
        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="4" cy="4" rx="4" ry="4" fill={`${status.toLowerCase() == 'passed' || status.toLowerCase() == 'normal' || status.toLowerCase() == 'negative' || status.toLowerCase() == 'confirmed negative' || status.toLowerCase() == 'administrated' || status.toLowerCase() == 'dispensed' || status.toLowerCase() == 'administered' ? '#0F8647' : status.toLowerCase() == 'not started' || status.toLowerCase() == 'not administered' ? '#1D2433CC' : status.toLowerCase() == 'failed' || status.toLowerCase() == 'cancelled'  || status.toLowerCase() == 'abnormal' || status.toLowerCase() == 'positive' || status.toLowerCase() == 'confirmed positive' || status.toLowerCase() == 'fail' || status.toLowerCase() == 'abnormal'? "#E02D3C" : '#CA8B14'}`}></ellipse>
        </svg>

      </span>
      {capitalizeName(status.toLowerCase())}
    </div>
  }

  activityStatusDetector = (activityStatus) => {
    const raw = (activityStatus || '').toString().trim() || 'Not Started';
    const statusText = raw.toLowerCase();
    const isSuccess = ['passed', 'completed', 'dispensed', 'administered', 'administrated', 'pass'].includes(statusText);
    const isPending = ['not started', 'notstarted', ].includes(statusText);
    const isDanger = ['failed','abnormal', 'fail', 'cancelled'].includes(statusText);
    const badgeClass = isSuccess ? 'sh_badgeSuccess' : isPending ? 'sh_badgePending' : isDanger ? 'sh_badgeDanger' : 'sh_badgeWarning';
    const dotFill = isSuccess ? '#0F8647' : isPending ? '#1D2433CC' : isDanger ? '#E02D3C' : '#CA8B14';
    return (
      <div className={`badge ${badgeClass}`}>
        <span className="pr-1">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="4" cy="4" rx="4" ry="4" fill={dotFill} />
          </svg>
        </span>
        {capitalizeName(statusText)}
      </div>
    );
  }

  fetchPhysicalList = ()=>{    
    if(this.state.isAssignCompany){
      this.getAssignCompanyOptionsForSelfRegister();
    }
    const {visitDetails} = this.props;
  const { profile } = this.props;
  const isEmployerAdmin = this.props.profileDetails?.role === 'employer_admin' || profile?.employer_login === true;
  const baseTableHeaders = [
    { label: 'Activity Name', key: 'activity_name',noTruncate: true },
    // { label: 'Activity Type', key: 'activity_type' },
    { label: 'Consent', key: 'consent' },
    { label: 'Result', key: 'status' },
    { label: 'Activity status', key: 'activity_status' },
    // { label: 'Signatory', key: 'signatory' },
  ];
  const tableHeaders = isEmployerAdmin
    ? baseTableHeaders
    : [...baseTableHeaders, { label: 'Action', key: 'action', type: 'Actions' }];
  let tableRows = [];
  let overAllStatus = visitDetails[0].overall_status;
  let passedCnt = 0;
  let notstartedCnt = 0;
  // let failedCnt = 0;
    let totalCnt = 0;
    const isCompanyEmployee=this.props.profileDetails?.employee_login;
    isSet(visitDetails?.mapping_activity?.data?.data,[]).forEach((item,itemIndex)=>{
    // Skip items where activity has been deleted
    if (!item?.activity) {
      return; // Skip this iteration
    }
    totalCnt = itemIndex +1;
    let status  = item.status;
    if (item.status=='Completed/Administrated') {
      item.status= 'passed';
      status='passed'
    }
    if (item.status=='Ordered') {
      item.status='pending'
      status='pending'
    }
    let statusClr = 'notStarted';
     if(status.toLowerCase()==='passed' || status ==='The subject Passed the fit test' || status.toLowerCase()==='normal' || status.toLowerCase()==='negative' || status.toLowerCase()==='pass' || status.toLowerCase()==='confirmed negative' || status.toLowerCase()==='administrated' || status.toLowerCase()==='completed' || status.toLowerCase()==='dispensed' || status.toLowerCase()==='administered'){
      statusClr = 'passed'; 
      passedCnt++;
    }else if(status==='Not Started' || status=='NOT STARTED' || status.toLowerCase()=='not started' || status.toLowerCase()=='notstarted' || status.toLowerCase()=='not administered'){
      statusClr ='notStarted';
      notstartedCnt++;
    }else if(status.toLowerCase()==='pending' ){
       statusClr = 'pending';
       if(item?.activity?.activity_type.toLowerCase()=='lab'){
        statusClr='pendingLab'
       }
    }else if(status.toLowerCase()==='pending mro'){
       statusClr='pendingMRO'
    }else if(status.toLowerCase()==='pending lab'){
       statusClr='pendingLab'
    }else  if(status.toLowerCase()==='failed' || status ==='The subject Failed the fit test' || status.toLowerCase()==='abnormal' || status.toLowerCase()==='positive' || status.toLowerCase()==='fail' || status.toLowerCase()==='confirmed positive' || status.toLowerCase()=='cancelled'){
      statusClr = 'failed';
      // failedCnt++;
      overAllStatus = 'Failed';
    }else{
        statusClr = 'pending';
    }
    const consentIcon = (isSet(item?.activity_consent_declination?.id,null)!==null)?'ConsentEdit':'ConsentAdd';
    
    tableRows = [
      ...tableRows,
      {
        physicalIndex: itemIndex,
        isHeading: false,
        rowId: item.physical_id,
        data: {
          isActive: false,
          activity_name: {
            value:
              <>
                <a className="px-1 pr-2" title={status} >
                  <Icons fontSize="15px" type={statusClr} />
                </a>
                <span title={item?.activity?.activity_name} >
                {item?.activity?.activity_name}
                </span>
              </>
          },
          activity_status:{
            title:item?.activity_status,
            value:(
              <div className="d-flex justify-content-left">
                {this.activityStatusDetector(item?.activity_status)}
              </div>
            )
          },
          status:{
            title:status,
            value:<>
            <div className="d-flex justify-content-left">
              {this.statusDetector(status)}
            {/* <div className="d-flex Justify-content-end px-2"><Icons type={statusClr} /></div> */}
            {/* <div >{capitalizeName(item.status.toLowerCase())}</div> */}
            </div>
            </>          
            },
          //isSet(item?.activity.active_consents,null)
          activity_type:item?.activity?.activity_type,
          consent:{
            value:(isSet(item?.activity?.active_consents,null)!==null)?
              (isEmployerAdmin ? <Icons type={consentIcon} readOnly title="View only - consent cannot be edited" /> : <Icons type={consentIcon} clickHandler={()=>this.activityConsentToogleHandler({...item?.activity,mapping_id:item.mapping_id,activityConsentDeclination:item?.activity_consent_declination})}/>)
              :<>-</>
          },
          // signatory: {
          //   value: isSet(item?.signoff_user_name, null) ? item.signoff_user_name : '-',
          // },
          ...(isEmployerAdmin ? {} : { action: [    
              {
                className: "btn px-0",      
                iconType:"Certificate",
                acl: ( item?.activity?.activity_type === 'Provider Exam' && visitDetails.providerExam.find(provider => provider.mapping_id === item.mapping_id)?.isFederalOrState === true ) ?'any': '',
                title: "Certificate",
                disableButtonTitle:"Certificate",
                iconColor:'#000',
                iconDropDownList:[{
                  label:'Examiner Certificate',
                  clickHandler:()=>this.printMedicalExaminationPdfs(item.mapping_id,'CERT','MedicalExaminationCertificate')
              },
              {
                  label:'Examination Report (DOT)',
                  clickHandler:()=>this.printMedicalExaminationPdfs(item.mapping_id,'DOT','MedicalExaminationReport')
              }]
             }
             ,         
              (item?.activity?.activity_type === 'Lab' && visitDetails.laboratory.find(lab => lab.mapping_id === item.mapping_id)?.hasOrder === false) ||
              (item?.activity?.activity_type === 'Vaccine' && visitDetails.vaccines.find(vaccine => vaccine.mapping_id === item.mapping_id)?.hasOrder === false)||
              (item?.activity?.activity_type === 'Lab - Point of Care' && visitDetails.laboratory.find(lab => lab.mapping_id === item.mapping_id)?.hasOrder === false)
              ?
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "AddPlus",
                title: "Add Order",
                acl: "visits-list",
                label: "",
                disabled: isEmployerAdmin,
                // acl: "any",
                clickHandler: () => this.orderLabToogleHandler(item?.activity?.activity_type,item),
              }
              :
              {
                className: "btn btn-icon btn-transparent-dark",
                iconType: "ActivityChart",
                // acl: isCompanyEmployee?"":'any',
                acl: "visits-list",
                title: 'Chart',
                disabled: isEmployerAdmin,
                clickHandler: () => this.activityChartToogleHandler({ ...(item?.activity || {}), mapping_id: item.mapping_id })
              }
            
              ,
            {
              className:
                "btn btn-icon btn-transparent-dark",
              iconType: "Remove",
              // acl: "any",
              acl: "visits-list",
              title: "Delete",
              disabled: isEmployerAdmin,
              isDelete:true,
              clickHandler: () =>this.deleteHandler(item.mapping_id),
            }, 
            {
                  className: "btn btn-icon px-1 btn-transparent-dark",
                  // iconType: "NewDetailViewIcon",
                  iconType: `Question_${item.questionnaires_status}`,
                  title:
                  item.questionnaires_status === "Default"
                    ? "Questionnaires Not Available"
                    : item.questionnaires_status === "Completed"
                    ? "Questionnaires are completed"
                    : item.questionnaires_status === "Sent"
                    ? "Questionnaires are already sent"
                    : item.questionnaires_status === "Available"
                    ? "Questionnaires are not sent yet"
                    : item.questionnaires_status,
                
                  label: "",
                  // acl: "employee-edit",
                  acl: "visits-list",
                  disabled: item.questionnaires_status === "Default", 
                  clickHandler: () => {
                    const blockedStatuses = ["Default", "Completed", "Sent"];
                    if (!blockedStatuses.includes(item.questionnaires_status)) {
                      this.sendQuestionnaireHandler(item.mapping_id);
                    }
                  },                  
                },
          ] }),
        },
      },
    ];
  })
if(totalCnt==passedCnt){
  overAllStatus = 'Passed';
}
if(notstartedCnt==totalCnt){
  overAllStatus = 'Not Started';
}
// if(failedCnt>0){
//   overAllStatus = 'Failed';
// }
  this.setState({
    overAllStatus: overAllStatus,
    tableRecords: {
      ...this.state.tableRecords,
      tableHeaders,
      tableRows: {
        type: "default",
        data: tableRows,
      },
      pagination: {
        ...this.state.tableRecords.pagination,
        page: visitDetails?.mapping_activity.pagination.current_page,
        perPage: visitDetails?.mapping_activity.data.per_page,
        totalRecords: visitDetails?.mapping_activity.pagination.totalCount,        
      },
    },
  });
  }
  orderLabToogleHandler = (type = '', chartDetails = {}) => {
    if (type == 'Lab'||type=='Lab - Point of Care' || type == 'Vaccine') {
      // For Lab and Vaccine activities, open the unified ActivityChart screen
      this.activityChartToogleHandler({ ...chartDetails.activity, mapping_id: chartDetails.mapping_id });
    }
  };
  // addVaccineToogleHandler=(chartDetails={})=>{
  //   this.setState({isVaccineModelOpen:!this.state.isVaccineModelOpen,activityChartDetails:chartDetails})
  // }
  addLabToogleHandler=(chartDetails={},chartOpen=false)=>{
    this.setState({isLabModelOpen:!this.state.isLabModelOpen,activityChartDetails:chartDetails});
  }

  getAssignCompanyOptionsForSelfRegister= async()=>{
    
    const {visitDetails} = this.props;
    const {employee} =visitDetails;
    const clinic_id = employee.clinic_id;
    const assignCompanyOptions = await DropDownService.getAssignCompanyOptionsForSelfRegister(clinic_id);
    let options=[{label:'-Select Company-',value:''}];
      assignCompanyOptions.forEach(val => {
        options.push({label:val.name,value:val.company_uuid});
      });
    //activity bundle
    this.setState({assignCompanyOptions:options})
  }

  fetchOptions=async()=>{
    //array of key for fetch 
    //fetch key value and store in keysOptions
    let activitiesResponse=await ActivitiesService.getActivities();
    // console.log('activitiesResponse',activitiesResponse);
      let options=[{label:'-Select-',value:''}];
      activitiesResponse.forEach(val => {
        options.push({label:val.activity_name,value:val.actitivity_id});
      });
    //activity bundle
    this.setState({options:options})
  }
  deleteHandler = async (id)=>{
    VisitsService.deleteActivityInChartInVisits(id)
    .then((res) => {
      //toast and show error logic
      this.props.fetchVisitDetails(this.props.visitDetails.visit_id,{...this.state.tableRecords.pagination,page:1,search_query:''});
      this.ClearSearch()
      this.props.Toast.success('Physical Deleted Successfully');
    })
    .catch((err) => {
      //
    })
    .finally(() => {
      //
    });
  }
}
const mapStateToProps = (state) => ({
  profileDetails: activeProfileDetails(state),
});

export default  connect(mapStateToProps)(WithRouter(WithRoutify(PhysicalTab)));
